/**
 * Related Products JS — Drag-to-scroll carousel with momentum + progress bar
 */
(function () {
  'use strict';

  var scrollEl = document.querySelector('[data-related-scroll]');
  var progressEl = document.querySelector('[data-related-progress]');
  if (!scrollEl) return;

  /* ── STATE ── */
  var isDragging = false;
  var startX = 0;
  var startScrollLeft = 0;
  var velocity = 0;
  var lastX = 0;
  var lastTime = 0;
  var animationFrame = null;

  /* ── PROGRESS BAR ── */
  function updateProgress() {
    if (!progressEl) return;
    var max = scrollEl.scrollWidth - scrollEl.clientWidth;
    var pct = max > 0 ? (scrollEl.scrollLeft / max) * 100 : 0;
    progressEl.style.width = Math.max(20, pct) + '%';
  }

  var ticking = false;
  scrollEl.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        updateProgress();
        ticking = false;
      });
    }
  }, { passive: true });

  /* ── MOUSE DRAG ── */
  scrollEl.addEventListener('mousedown', function (e) {
    isDragging = true;
    startX = e.pageX;
    startScrollLeft = scrollEl.scrollLeft;
    lastX = e.pageX;
    lastTime = Date.now();
    velocity = 0;
    scrollEl.style.cursor = 'grabbing';
    scrollEl.style.userSelect = 'none';
    if (animationFrame) cancelAnimationFrame(animationFrame);
  });

  document.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    e.preventDefault();
    var dx = e.pageX - startX;
    scrollEl.scrollLeft = startScrollLeft - dx;

    // Track velocity
    var now = Date.now();
    var dt = now - lastTime;
    if (dt > 0) {
      velocity = (e.pageX - lastX) / dt;
    }
    lastX = e.pageX;
    lastTime = now;
  });

  document.addEventListener('mouseup', function () {
    if (!isDragging) return;
    isDragging = false;
    scrollEl.style.cursor = 'grab';
    scrollEl.style.userSelect = '';

    // Momentum scrolling
    if (Math.abs(velocity) > 0.1) {
      var momentumVelocity = velocity * 150;
      var friction = 0.95;

      function momentum() {
        if (Math.abs(momentumVelocity) < 0.5) return;
        scrollEl.scrollLeft -= momentumVelocity * 0.016;
        momentumVelocity *= friction;
        animationFrame = requestAnimationFrame(momentum);
      }
      momentum();
    }
  });

  /* ── TOUCH SUPPORT (native scroll is fine, just update progress) ── */
  scrollEl.addEventListener('touchstart', function () {
    if (animationFrame) cancelAnimationFrame(animationFrame);
  }, { passive: true });

  /* ── PREVENT LINK CLICKS DURING DRAG ── */
  scrollEl.addEventListener('click', function (e) {
    if (Math.abs(startX - (e.pageX || 0)) > 5) {
      e.preventDefault();
    }
  }, true);

  // Initial progress
  updateProgress();
})();
